import {consoleSink} from './consoleSink'
import {createLogger} from './createLogger'
import type {LogSink} from './types'

// The requires sit in if/else branches so webpack drops the ones that do not apply to each build (pino, Datadog).
const selectSink = (): LogSink => {
  if (typeof window !== 'undefined') {
    const browserModule: typeof import('./browserSink') = require('./browserSink')

    return browserModule.browserSink
  } else if (process.env.NEXT_RUNTIME === 'edge') {
    return consoleSink
  } else {
    const serverModule: typeof import('./serverSink') = require('./serverSink')

    return serverModule.serverSink
  }
}

export const logger = createLogger(selectSink())
